/* src/app/attendee/attendee.component.scss */
/*# sourceMappingURL=attendee.component.css.map */
